export default [
  {
    for: 'job',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
];
